
namespace Matrix.Indexation {

    @Serenity.Decorators.registerEditor('Matrix.Indexation.IndexationProfileCompositeConstituentGrid')
    export class IndexationProfileCompositeConstituentGrid extends SiteEntityGrid<CompositeConstituentRow, any> {
        protected getColumnsKey() { return CompositeConstituentColumns.columnsKey; }
        protected getDialogType() { return CompositeConstituentDialog; }
        protected getIdProperty() { return CompositeConstituentRow.idProperty; }
        protected getInsertPermission() { return CompositeConstituentRow.insertPermission; }
        protected getLocalTextPrefix() { return CompositeConstituentRow.localTextPrefix; }
        protected getService() { return CompositeConstituentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        getInitialTitle() {
            return null;
        }

        private _indexationProfileCode: string;

        get indexationProfileCode(): string {
            return this._indexationProfileCode;
        }

        set indexationProfileCode(value: string) {
            if (this._indexationProfileCode != value) {
                this._indexationProfileCode = value;
                this.setEquality(CompositeConstituentRow.Fields.IndexationProfileCode, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._indexationProfileCode;
        }
    }
}